/**
 * 頁面權限：選單與路由守衛共用同一份路由設定上的權限欄位，
 * 確保「選單看不到的頁面就是不能用」（直接輸入網址也會被擋下）。
 *
 * 路由設定上可用的權限欄位：
 * - `roles`: 允許進入的角色清單（例如 ['admin', 'accounting']），未設定代表所有已登入角色皆可
 * - `adminOnly`: 僅限管理員（role `admin`）
 *
 * 巢狀路由（例如 /setting/space）需要父層與子層都允許才可進入。
 */

/** 被擋下時導回的頁面（所有角色都能使用） */
export const FALLBACK_PATH = '/reserve';

/** 單一路由設定是否允許該角色使用 */
export function isRouteAllowed(routeDef, role) {
  if (!routeDef) {
    return true;
  }
  if (routeDef.adminOnly && role !== 'admin') {
    return false;
  }
  if (Array.isArray(routeDef.roles) && !routeDef.roles.includes(role)) {
    return false;
  }
  return true;
}

/** 在路由設定樹中依 name 找出設定 */
function findRouteDef(routes, name) {
  for (let i = 0; i < routes.length; i += 1) {
    const r = routes[i];
    if (r.name === name) {
      return r;
    }
    if (Array.isArray(r.children)) {
      const found = findRouteDef(r.children, name);
      if (found) {
        return found;
      }
    }
  }
  return undefined;
}

/** 依路由 name 判斷該角色能否使用（name 找不到設定時視為允許） */
export function isRouteNameAllowed(routes, name, role) {
  return isRouteAllowed(findRouteDef(routes, name), role);
}

/**
 * 檢查目標路由（vue-router 的 Route 物件）是否允許該角色進入。
 * 允許時回傳 undefined；不允許時回傳應導向的路徑：
 * 優先導回最近一層允許的父頁面（例如 /setting），否則導回 FALLBACK_PATH。
 */
export function getForbiddenRedirect(routes, to, role) {
  const matched = to.matched || [];
  let lastAllowedPath;
  for (let i = 0; i < matched.length; i += 1) {
    const record = matched[i];
    if (!isRouteNameAllowed(routes, record.name, role)) {
      return lastAllowedPath || FALLBACK_PATH;
    }
    // 只有無參數的路徑才適合直接導回
    if (record.path && record.path.indexOf(':') < 0) {
      lastAllowedPath = record.path;
    }
  }
  return undefined;
}
